import styled from 'styled-components'
// components
import { Modal } from 'components/UI'
// themes
import colors from 'themes/colors'

export const Header = styled.div`
  position: relative;
  height: 48px;
  color: ${colors.blue500};
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  padding: 0 20px;
`

export const ModalContent = styled.div`
  overflow: auto;
  width: calc(100% - 20px);
  height: 100%;
`

export const StyledModal = styled(Modal)`
  @media (max-width: 768px) {
    > .MuiDialog-paper {
      height: 100vh;
      width: 100vw;
      margin: 0;
      border-radius: 0;
    }
  }
`

export const Description = styled.span`
  margin-left: 20px;
  font-weight: normal;
`
